import React from 'react';
import { ReactComponent as DatePickerCalendarSVG } from './datePickerCalendar.svg';
import { ReactComponent as DatePickerCloseSVG } from './datePickerClose.svg';

export const DatePickerCalendar: React.FC = (props) => <DatePickerCalendarSVG {...props} />;

export const DatePickerClose: React.FC = (props) => <DatePickerCloseSVG {...props} />;
